export default "__VITE_ASSET__BYLs0X9n__"